import { createContext, Dispatch, SetStateAction } from 'react'
import type { MainNavigate } from '../typings/MainNavigate'

export const MainNavigateContext = createContext<MainNavigate | undefined>(
  undefined
)
export const SetMainNavigateContext = createContext<
  Dispatch<SetStateAction<MainNavigate | undefined>> | undefined
>(undefined)
